interface Props {
  url: string | null | undefined;
  title: string;
  author?: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizes = {
  sm: { w: "w-16", h: "h-24", text: "text-[0.55rem]" },
  md: { w: "w-28", h: "h-40", text: "text-[0.7rem]" },
  lg: { w: "w-40", h: "h-60", text: "text-xs" },
  xl: { w: "w-52 sm:w-64", h: "h-80 sm:h-96", text: "text-sm" },
};

export function BookCover({ url, title, author, size = "md", className = "" }: Props) {
  const s = sizes[size];
  const shadow =
    size === "xl"
      ? "shadow-[0_8px_16px_rgba(61,43,61,0.10),_0_24px_60px_rgba(199,123,133,0.25)]"
      : "shadow-[0_4px_8px_rgba(61,43,61,0.06),_0_12px_28px_rgba(199,123,133,0.18)]";

  return (
    <div
      className={[
        s.w,
        s.h,
        "relative shrink-0 rounded-md overflow-hidden",
        shadow,
        "transition-transform duration-300 ease-out",
        className,
      ].join(" ")}
    >
      {url ? (
        <img
          src={url}
          alt={`Cover of ${title}`}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-blush-soft via-blush to-rose-light flex flex-col items-center justify-center px-3 text-center text-white">
          <span className={`font-serif ${s.text} leading-tight tracking-tight italic`}>
            {title}
          </span>
          {author && size !== "sm" ? (
            <span className={`mt-2 ${s.text} opacity-80`}>{author}</span>
          ) : null}
        </div>
      )}
      {/* subtle inner edge */}
      <div className="absolute inset-0 ring-1 ring-inset ring-black/5 rounded-md pointer-events-none" />
      <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-black/20" />
    </div>
  );
}
